import React, { useContext } from "react"
import { AICreditsPanel } from "./AICreditsPanel.jsx"
import { AIStateContext } from "../providers/AIStateProvider.jsx"
import { Button } from "@shopify/polaris"
import { useTranslation } from "react-i18next"

export const CreditsTopUpOverlay = () => {
	const { aiState, setAIState } = useContext(AIStateContext)
	const { t } = useTranslation()

	if (aiState.isCreditsTopUpOverlayOpen === false) {
		return ""
	}

	return (
		<div
			style={{
				position: "fixed",
				top: "0",
				left: "0",
				right: "0",
				bottom: "0",
				height: "100%",
				width: "100%",
				zIndex: "550",
				background: "rgba(0, 0, 0, 0.3)",
				backdropFilter: "blur(5px)",
				display: "flex",
				flexDirection: "column",
				gap: "1rem",
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<AICreditsPanel
				onTopUpComplete={() =>
					setAIState({ isCreditsTopUpOverlayOpen: false })
				}
			/>
			<Button
				onClick={() => setAIState({ isCreditsTopUpOverlayOpen: false })}
			>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.3rem",
						color: "red",
					}}
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="1rem"
						height="1rem"
						viewBox="0 0 24 24"
					>
						<path
							fill="currentColor"
							d="M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m0 2c-1.9 0-3.6.6-4.9 1.7l11.2 11.2c1-1.4 1.7-3.1 1.7-4.9c0-4.4-3.6-8-8-8m4.9 14.3L5.7 7.1C4.6 8.4 4 10.1 4 12c0 4.4 3.6 8 8 8c1.9 0 3.6-.6 4.9-1.7"
						></path>
					</svg>
					<span style={{ fontSize: "0.9rem" }}>
						{t("common.cancel")}
					</span>
				</div>
			</Button>
		</div>
	)
}
